import { post } from '../services/api';
import { MetricsKeys } from '../constants';

type ActionType =
  | 'click-on-button'
  | 'click'
  | 'search'
  | 'click-select'
  | 'download';

type ExtraDataType = {
  path?: string;
  button: string;
};

type Metric = {
  action: ActionType;
  extra_data: ExtraDataType;
};

type HomeEvent = {
  action: string;
  section?: string;
  companies?: string[];
  extra_data?: Record<string, any>;
};

export const useMetrics = () => {
  const userId = window.localStorage.getItem('user_id');
  const path = window.location.pathname;

  const track = (log: Metric) => {
    post('utils/metrics/', {
      user_pk: userId,
      action: log.action,
      extra_data: {
        button: log.extra_data.button,
        path,
      },
    });
  };

  /** Tracks structured home events matching the u.hacku metrics contract. */
  const trackEvent = (event: HomeEvent) => {
    post('utils/metrics/', {
      user_pk: userId,
      action: event.action,
      section: event.section,
      companies: event.companies,
      extra_data: event.extra_data ?? {},
    });
  };

  return { track, trackEvent, MetricsKeys };
};
